package com.yogaaicoach.pages.auth

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.yogaaicoach.pages.auth.firebase.AuthError
import com.yogaaicoach.pages.auth.firebase.FirebaseService
import com.yogaaicoach.pages.auth.firebase.platformSignInWithEmailPassword
import com.yogaaicoach.pages.auth.firebase.resendEmailVerificationPlatform
import com.yogaaicoach.user.UserInfo
import io.github.aakira.napier.Napier
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch

class EmailPasswordSignInViewModel(private val firebaseService: FirebaseService) : ViewModel() {
    private val _email = MutableStateFlow("")
    val email: StateFlow<String> = _email

    private val _password = MutableStateFlow("")
    val password: StateFlow<String> = _password

    private val _error = MutableStateFlow("")
    val error: StateFlow<String> = _error

    private val _showVerificationResendLink = MutableStateFlow(false)
    val showVerificationResendLink: StateFlow<Boolean> = _showVerificationResendLink

    private val _isLoading = MutableStateFlow(false)
    val isLoading: StateFlow<Boolean> = _isLoading

    fun onEmailChange(emailInput: String) {
        _email.value = emailInput
    }

    fun onPasswordChange(passwordInput: String) {
        _password.value = passwordInput
    }

    fun onResendVerificationEmail(onNavigateToVerifyEmail: (email: String) -> Unit) {
        viewModelScope.launch {
            resendEmailVerificationPlatform()
            onNavigateToVerifyEmail(_email.value)
        }
    }

    fun onSignIn(onLoginSuccess: (UserInfo) -> Unit) {
        viewModelScope.launch {
            _isLoading.value = true
            val result = platformSignInWithEmailPassword(_email.value, _password.value)
            _isLoading.value = false
            result.onSuccess { userInfo ->
                Napier.d("Success")
                onLoginSuccess(userInfo)
            }
            result.onFailure { err ->
                _error.value = firebaseService.mapErrorMessage(err)
                _showVerificationResendLink.value = err is AuthError.UserNotActivated
            }
        }
    }
}
